/**
 * SetplexLoginCtrl controller
 */

/**
 * SetplexLoginCtrl controller
 *
 * @class SetplexLoginCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:SetplexLoginCtrl
 */
/* @ngInject */
export default function SetplexLoginCtrl ($rootScope, $q, $state, $transition$, $location, $scope, authSvc, notifySvc, alertSvc) {
  var vm = this

  const { go } = $transition$ ? $transition$.params() : {}

  /**
   * Perform login
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   */
  vm.doLogin = function () { // should contain 'username' and 'password' fields
    const message = (code) =>
      code >= 500 ? 'Something went wrong. Please try again later.' : code === 403 ? 'User is disabled' :         // eslint-disable-line
                                       'Invalid email or password'  // eslint-disable-line
    return authSvc.doKeycloakLogin()
      .then(
        () => {
          notifySvc.add('Logged in')
          if ($scope.modalInstance) {
            $scope.modalInstance.close()
          } else {
            if (go) {
              $location.url(go)
            } else {
              $state.go('app.dashboard')
            }
          }
        }
      )
      .catch(
        response => {
          alertSvc.alert(message(response.status), 'danger')
          if ($scope.modalInstance) {
            $scope.modalInstance.dismiss('cancel')
          } else {
            $state.go('login')
          }
        }
      )
  }

  /**
   * Perform logout
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   */
  vm.doLogout = function () {
    authSvc.doLogout()
      .finally(
        () => {
          notifySvc.clear()
          if ($scope.modalInstance) {
            $scope.modalInstance.dismiss('cancel')
          }
        }
      )
  }

  vm.loadImage = function(img) {
    return require('../../img/' + window.ENV.APP_PROVIDER + '/' + window.ENV.APP_PROVIDER + img)
  }
  vm.hasKeycloak = function(){
    return authSvc.hasKeycloak()
  }
  
  // init timezone request
  vm.initTimezoneRequest = function(){
    authSvc.timezone()
    .then(function(){
      return vm.hasKeycloak()
      ? $q.resolve(true)
      : authSvc.getCredentials() // try to get credentials from Credentials API
          .then((user) => (vm.user = user)) // and login with them
    }).then(vm.doLogin)
        .catch((err) => console.warn(err))
  }

  if (vm.hasKeycloak()) {
    authSvc.keycloakInitEventSubscribe(go,true);
    $rootScope.$on('event:keycloakInited', function () {
      vm.initTimezoneRequest()
    })
  } else {
    $location.url('/login')
  }

}
